<app-card-template [config]="cardTemplateConfig">
  <div cardHeaderActions *ngIf="enableBidManagement">
    <div class="management-actions">
      <app-action-loader #deleteLastLoader>
        <button
          mat-raised-button
          color="accent"
          type="button"
          tabindex="5"
          (click)="onDeleteLastBid()"
          [disabled]="!canDeleteBids || !(hasBids$ | async) || deleteLastLoader.isRunning"
        >
          Eliminar última
        </button>
      </app-action-loader>
      <app-action-loader #deleteAllLoader>
        <button
          mat-raised-button
          color="accent"
          type="button"
          tabindex="6"
          (click)="onDeleteAllBids()"
          [disabled]="!canDeleteBids || !(hasBids$ | async) || deleteAllLoader.isRunning"
        >
          Eliminar todas
        </button>
      </app-action-loader>
    </div>
  </div>

  <div *ngIf="isLoading$ | async" class="loading">
    <p>Cargando pujas...</p>
  </div>

  <div *ngIf="error$ | async as error" class="error">
    <p>{{ error }}</p>
  </div>

  <ng-container *ngIf="!(isLoading$ | async) && !(error$ | async)">
    <ng-container *ngIf="bids$ | async as bids">
      <div *ngIf="bids.length > 0; else noBids" class="bids-list">
        <div
          *ngFor="let bid of bids; let i = index"
          class="bid-item"
          [ngClass]="{ 'bid-item--winner': isWinningBid(i) }"
        >
          <img
            src="assets/images/racket.svg"
            alt="racket"
            class="bid-icon"
            width="40"
            height="40"
          />
          <div class="bid-content">
            <div class="bid-header">
              <span class="username">{{ bid.username }} - {{ bid.clientName }}</span>
              <span
                class="bid-origin"
                [ngClass]="'bid-origin--' + bid.originType.toLowerCase()"
              >
                {{ bidOriginLabels[bid.originType] }}
              </span>
            </div>
            <div class="bid-details">
              <span class="bid-value">{{
                bid.value | multiMoney : 'Hizo una puja por' : exchangeRates
              }}</span>
              <span class="bid-date">{{ bid.date | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noBids>
    <div class="no-bids">
      <p>No hay pujas recientes</p>
    </div>
  </ng-template>
</app-card-template>
